import { UserSuggestFilter } from 'lib/api/friends';

export type Follow = 'FOLLOW' | 'UNFOLLOW';

export interface IFollowMutation {
  userid: number | string;
  type: Follow;
}

export interface IDeleteSuggestedItem {
  id: number;
}

interface IUserSuggestedFilter {
  FILTER_UNSPECIFIED: UserSuggestFilter,
  FILTER_ALL: UserSuggestFilter,
  FILTER_STREAM: UserSuggestFilter,
  FILTER_ONBOARDING: UserSuggestFilter,
}

export const FOLLOW_ACTION = {
  FOLLOW: <Follow>'FOLLOW',
  UNFOLLOW: <Follow>'UNFOLLOW',
};

export const QUERY_KEY_DATA = {
  suggested: 'getSuggestFriendsStreamWidget',
};

export const USER_SUGGESTED_FILTER: IUserSuggestedFilter = {
  FILTER_UNSPECIFIED: 'FILTER_UNSPECIFIED',
  FILTER_ALL: 'FILTER_ALL',
  FILTER_STREAM: 'FILTER_STREAM',
  FILTER_ONBOARDING: 'FILTER_ONBOARDING',
};

export const SWIPER_PARAMS = {
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  initialSlide: 0,
  arrows: true,
  responsive: [
    {
      breakpoint: 720,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: 425,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
  ],
};
